module.exports = __webpack_public_path__ + "static/img/log_new.73bb5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/dzy/assets/img/log_new.png
// module id = X8Kc
// module chunks = 43